<section class="cards__section" [ngClass]="sectionClass">
  <div class="cards__section-container">
    @if (title && !isFirstSection) {
      <h2 class="cards__title" [innerHTML]="title | translate"></h2>
    }
    @if (title && isFirstSection) {
      <h1 class="cards__title" [innerHTML]="title | translate"></h1>
    }
    @if (titleImgSrc) {
      <img
        class="cards__title-image"
        [src]="titleImgSrc"
        [alt]="titleImgAltText ? titleImgAltText : title"
        sizes="(max-width: 136px) 100vw, 136px"
      />
    }
    @if (subtitle) {
      <p class="cards__subtitle" [innerHTML]="subtitle"></p>
    }
  </div>

  @if (numbers) {
    <div class="cards__section-container cards__card-number__container">
      @for (card of contents; track card; let cardIteration = $index) {
        <div class="cards__card-number-desktop">
          <div class="cards__card-divider"></div>
          <div class="cards__card-number">
            <span>{{ cardIteration + 1 }}</span>
          </div>
        </div>
      }
    </div>
  }
  <div class="cards__section-container cards__container">
    @for (card of contents; track card; let cardIteration = $index) {
      <div class="cards__card-wrapper">
        @if (numbers) {
          <div class="cards__card-number-tablet">
            <div class="cards__card-divider"></div>
            <div class="cards__card-number">
              <span>{{ cardIteration + 1 }}</span>
            </div>
          </div>
        }

        <div class="cards__card">
          <div class="cards__card__content">
            @if (card.imgSrc) {
              <div class="card-responsive-slider__card__img">
                @if (!pageConfigService.isSafari()) {
                  <picture>
                    <img
                      [src]="card.imgSrc"
                      [alt]="card.imgAltText ? card.imgAltText : card.title"
                      style="width: auto"
                    />
                  </picture>
                }
                @if (pageConfigService.isSafari()) {
                  <img
                    [src]="card.imgSrc"
                    [alt]="card.imgAltText ? card.imgAltText : card.title"
                    style="width: auto"
                  />
                }
              </div>
            }
            <div class="card-responsive-slider__card__title">
              {{ card.title }}
            </div>
            @if (card.description) {
              <div
                class="card-responsive-slider__card__description"
                [innerHTML]="card.description"
              ></div>
            }
          </div>
        </div>
      </div>
    }
  </div>
  <ul class="cards__section-container card-responsive-slider__slider">
    @for (card of contents; track card; let cardIteration = $index) {
      <li class="card-responsive-slider__card-wrapper">
        <div class="card-responsive-slider__card">
          <div class="card-responsive-slider__card__content">
            @if (card.imgSrc) {
              <div class="card-responsive-slider__card__img">
                @if (!pageConfigService.isSafari()) {
                  <picture>
                    <img
                      [src]="card.imgSrc"
                      [alt]="card.imgAltText ? card.imgAltText : card.title"
                      style="width: auto"
                    />
                  </picture>
                }
                @if (pageConfigService.isSafari()) {
                  <img
                    [src]="card.imgSrc"
                    [alt]="card.imgAltText ? card.imgAltText : card.title"
                    style="width: auto"
                  />
                }
              </div>
            }
            <div class="card-responsive-slider__card__title">
              <span class="card-responsive-slider__card__title__number"
                >{{ cardIteration + 1 }}.</span
              >
              {{ card.title }}
            </div>
            @if (card.description) {
              <div
                class="card-responsive-slider__card__description"
                [innerHTML]="card.description"
              ></div>
            }
          </div>
        </div>
      </li>
    }
  </ul>
</section>
